import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/toaster';
import { CookieBanner } from '@/components/legal/CookieBanner';
import { Analytics } from '@vercel/analytics/react';
import BalleranoSite from './BalleranoSite-v2';
import { LazyPage } from './routeRegistry';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
    },
  },
});
// Restore public newsletter data captured by prerender before React hydrates.
// It keeps the first client render aligned with the static issue HTML.
const initialNewsletter = window.__NEWSLETTER_CACHE__;
if (initialNewsletter?.length) {
  if (initialNewsletter.length > 1) {
    queryClient.setQueryData(['issues'], initialNewsletter, { updatedAt: 0 });
    queryClient.setQueryData(
      ['newsletter-issues-page-it'],
      initialNewsletter.slice(0, 5),
      { updatedAt: 0 },
    );
  }
  for (const issue of initialNewsletter)
    queryClient.setQueryData(['issue-it', issue.issue_number], issue, {
      updatedAt: 0,
    });
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Toaster position="top-right" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BalleranoSite />} />
          <Route path="/chi-sono" element={<LazyPage route="/chi-sono" />} />
          <Route path="/servizi" element={<LazyPage route="/servizi" />} />
          <Route
            path="/ai-consulting-services"
            element={<LazyPage route="/ai-consulting-services" />}
          />
          <Route
            path="/metodologia"
            element={<LazyPage route="/metodologia" />}
          />
          <Route
            path="/newsletter"
            element={<LazyPage route="/newsletter" />}
          />
          <Route
            path="/conferma-iscrizione"
            element={<LazyPage route="/conferma-iscrizione" />}
          />
          <Route
            path="/unsubscribe"
            element={<LazyPage route="/unsubscribe" />}
          />
          <Route
            path="/vibe-coder"
            element={<LazyPage route="/vibe-coder" />}
          />
          <Route
            path="/progetti"
            element={<Navigate to="/vibe-coder" replace />}
          />
          <Route
            path="/testimonianze"
            element={<LazyPage route="/testimonianze" />}
          />
          <Route path="/archivio" element={<LazyPage route="/archivio" />} />
          <Route
            path="/numero/:numero"
            element={<LazyPage route="/numero/:numero" />}
          />
          <Route
            path="/privacy-policy"
            element={<LazyPage route="/privacy-policy" />}
          />
          <Route
            path="/cookie-policy"
            element={<LazyPage route="/cookie-policy" />}
          />
          <Route path="/extra" element={<LazyPage route="/extra" />} />
          <Route path="/blog" element={<LazyPage route="/blog" />} />
          <Route
            path="/blog/:slug"
            element={<LazyPage route="/blog/:slug" />}
          />
          <Route
            path="/umani-per-ora"
            element={<LazyPage route="/umani-per-ora" />}
          />
          <Route
            path="/press-kit-umani-per-ora"
            element={<LazyPage route="/press-kit-umani-per-ora" />}
          />
          <Route
            path="/guida-ai-azienda"
            element={<LazyPage route="/guida-ai-azienda" />}
          />
          <Route
            path="/termini-servizio"
            element={<LazyPage route="/termini-servizio" />}
          />
          {/* Redirects */}
          <Route
            path="/numeri-concreti"
            element={<Navigate to="/chi-sono" replace />}
          />
          {/* Catch-all: pagina 404 (noindex). Vercel serve dist/404.html con status 404. */}
          <Route path="*" element={<LazyPage route="/404" />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
      <Analytics />
    </QueryClientProvider>
  );
}

export default App;
